import { render, staticRenderFns } from "./FancyTextarea.vue?vue&type=template&id=382bc3a7&"
import script from "./FancyTextarea.vue?vue&type=script&lang=js&"
export * from "./FancyTextarea.vue?vue&type=script&lang=js&"
import style0 from "./FancyTextarea.vue?vue&type=style&index=0&id=382bc3a7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports